import { ApiResponseStatusUnauthorized, ApiResponseSuccess, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, PaymentTypeOptions, RentalOptions } from "utils/Constant";
import { useModal } from "../../components/modal/ModalContext";
import useFetch from "utils/hooks/useFetch";
import { ApiCreateOrderRental, ApiCreateSalesOrder, ApiGetCategoryList, ApiGetCustomerList, ApiGetOrderRentalStockList } from "utils/constants/api";
import { useEffect, useMemo, useState } from "react";
import { CheckResponse, money, removeNonNumeric } from "utils/helpers";
import NoImage from "assets/images/no-image.png";
import { FormCard, PagesTitle } from "components/Cards";
import StateManagedSelect from "react-select";
import DatePicker from "components/Input/DatePicker";
import moment from "moment";

export default function RentalOrder(){
  const {openModal, closeModal} = useModal()

  const { fetch: apiGetCategoryList } = useFetch(ApiGetCategoryList)
  const { fetch: apiGetRentalStockList } = useFetch(ApiGetOrderRentalStockList)
  const { fetch: apiGetCustomer } = useFetch(ApiGetCustomerList)
  const { fetch: apiCreateRentalOrder } = useFetch(ApiCreateOrderRental)

  const [categoryOptions, setCategoryOptions] = useState([])
  const [categoryId, setCategoryId] = useState('')
  const [cart, setCart] = useState([])
  const [searchParam, setSearchParam] = useState('')
  const [discount, setDiscount] = useState('0')
  const [rentalStockList, setRentalStockList] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [paymentType, setPaymentType] = useState('1')
  const [rentalDate, setRentalDate] = useState(new Date())
  const [customerOptions, setCustomerOptions] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [selectedRentalOptions, setSelectedRentalOptions] = useState('2')
  const [duration, setDuration] = useState('1')
  const [deliveryFee, setDeliveryFee] = useState('0')
  const [deliveryDate, setDeliveryDate] = useState(new Date())
  const [deliveryLocation, setDeliveryLocation] = useState('')
  const [remark, setRemark] = useState('')

  const [amount, setAmount] = useState('')
  const [nettAmount, setNettAmount] = useState('')

  const filteredList = useMemo(() => {
    if (!Array.isArray(rentalStockList)) return [];
    
    return rentalStockList.filter((item) => {
      const matchCategory =
        !categoryId || item.categoryId === Number(categoryId);

      const matchSearch =
        !searchParam ||
        item.productName?.toLowerCase().includes(searchParam.toLowerCase()) || // match productName
      item.brandName?.toLowerCase().includes(searchParam.toLowerCase());    // match brandName

      return matchCategory && matchSearch;
    });
  }, [rentalStockList, categoryId, searchParam]);

  // API Calls
  const getCategoryList = async() => {
      let res = await apiGetCategoryList({
          data: {
              categoryName: '',
              status: '1',
              pageSize: 1000,
              pageIndex: 0
          }
      })

      return res
  }
  const getSalesStockList = async() => {
      let res = await apiGetRentalStockList({
          data: {
              categoryId: '',
              searchParam: ''
          }
      })

      return res
  }
  const createOrder = async() => {
    let res = await apiCreateRentalOrder({
          data: {
            productId: selectedItem.productId, 
            customerId: selectedCustomer.value,
            rentalDate: moment(rentalDate).format("YYYY-MM-DDTHH:mm:ss"),
            rentalOptions: selectedRentalOptions, 
            quantity: duration,
            amount: amount,
            discount: discount === '' ? 0 : discount,
            deliveryFee: deliveryFee.replaceAll(',', ''),
            deliveryDate: moment(deliveryDate).format("YYYY-MM-DDTHH:mm:ss"),
            deliveryLocation,
            nettAmount: nettAmount,
            paymentType,
            remark
          }
      })

      return res
  }
  const getCustomerList = async(customerName) => {
      let res = await apiGetCustomer({
          data: {
              customerName,
              status: '1',
              pageSize: 100,
              pageIndex: parseInt(0)
          }
      })

      return res
  }

  const checkResponse = (response) => {
      if(response.status === ApiResponseSuccess){
          return true
      }else if(response.status === ApiResponseStatusUnauthorized){
          window.location.href = "/login"
      }else{
          openModal(ModalTypeFail, { message: response.message })
          return false
      }
  }

  // Event 
  const customerOnInput = (e) => {
    if (e.length > 3) {
      getCustomerList(e).then((res) => {
        if (checkResponse(res)) {
          let data = res?.data?.listData

          const arr = data?.map(x => ({
            label: x.customerName,
            value: String(x.customerId),
          }));

          setCustomerOptions(arr)
        }
      })
    }
    
  }

  // Button Event
  const rentBtnClick = (data) => {
      setSelectedItem(data)
      setShowModal(true)
  }
  const submitBtnClick = () => {
    openModal(ModalTypeLoading)

    if (selectedCustomer === null) {
      openModal(ModalTypeFail, { message: "Customer must be selected!" })
      return
    }

    createOrder().then((res) => {
      if (CheckResponse(res)){
        getSalesStockList().then((res) => {
          setRentalStockList(res.data.listData)
          setSearchParam('')
          setCategoryId('')

          openModal(ModalTypeSuccess, {
              onSuccess: () => {
                  closeModal()
              }
          })
        })
        setCart([])
      } else {
        openModal(ModalTypeFail, { message: res.message })
      }
    })
  }

  useEffect(() => {
    openModal(ModalTypeLoading)

    getCategoryList().then((res) => {
      if (checkResponse(res)) {
        let data = res?.data?.listData
        let tempData = [{ label: 'All', value: '' }]

        data.map((data, i) => tempData.push({ label: data.categoryName, value: String(data.categoryId)}))

        setCategoryOptions(tempData)
        setCategoryId(tempData[0].value)

        getSalesStockList().then((res) => {
          if (checkResponse(res)) {
            setRentalStockList(res.data.listData)
            closeModal()
          }
        })
      }
    })
  }, [])

  useEffect(() => {
    let amount = parseInt(duration) * parseFloat(selectedRentalOptions === '1' ? selectedItem.rentalPriceHour : (selectedRentalOptions === '2' ? selectedItem.rentalPriceSession : selectedItem.rentalPriceDay))
    let disc = discount === '' ? 0 : parseInt(discount)
    let otherFee = deliveryFee === '' ? 0 : parseFloat(deliveryFee.replaceAll(',', ''))
    let netto = (amount * (100 - disc) / 100) + otherFee

    setAmount(amount)
    setNettAmount(netto)
  }, [duration, discount, deliveryFee, selectedRentalOptions, showModal])

  return (
    <div className="p-3 h-screen overflow-hidden">
      <div className="w-full h-full bg-white sm:border rounded-xl sm:p-6 flex flex-col">

        {/* TITLE */}
        <PagesTitle title={'Rental Order'} />

        {/* CONTENT */}
        <div className="flex flex-1 gap-4 min-h-0 mt-4">

          {/* LEFT — SCROLLABLE */}
          <div className="w-full flex flex-col min-h-0 overflow-y-auto">

            {/* SEARCH BAR */}
            <div>
              <input
                className="border rounded-full w-full px-5 py-2"
                value={searchParam}
                onChange={(e) => setSearchParam(e.target.value)}
                placeholder="Search"
              />
            </div>

            {/* CATEGORY */}
            <div className="border flex gap-2 mt-3 bg-white shadow-md p-2 rounded-xl w-full
              min-h-14 overflow-x-auto flex-nowrap">
              {categoryOptions?.map((data, i) => (
                <div
                  key={i}
                  onClick={() => setCategoryId(data.value)}
                  className={`border rounded-xl px-3 cursor-pointer flex items-center justify-center
                    ${categoryId === String(data.value)
                      ? 'bg-black text-white'
                      : 'bg-white text-black'}`}
                >
                  <span className={`${categoryId === String(data.value) ? 'font-normal' : 'font-light'} whitespace-nowrap`}>{data.label}</span>
                </div>
              ))}
            </div>

            {/* PRODUCTS — this will overflow */}
            <div className="bg-white mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {filteredList?.map((data, i) => {              
                return (
                  <div className="flex flex-col justify-between border rounded-lg p-3" key={i}>
                    <div>
                      <div className="w-full h-48 bg-gray-100 rounded" >
                        {/* IMAGE PLACEHOLDER */}
                        <img src={data.imageUrl === '' ? NoImage : data.imageUrl} alt={data.productName} className="w-full h-full object-contain rounded" />
                      </div>

                      <div className="flex flex-col mt-2">
                        <span className="">{data.brandName} - { data.productName }</span>
                        <div className="flex flex-col w-full">
                          <div className="flex flex-col">                        
                            <span className="text-sm font-thin">
                              Rp {money(data.rentalPriceSession)} / Session
                            </span>                            
                            <span className="text-sm font-thin">
                              Rp {money(data.rentalPriceDay)} / Day
                            </span>
                          </div>
                        </div>
                        
                        <span className="font-thin text-sm text-gray-400">
                          Stock : { data.stock }
                        </span>
                      </div>
                    </div>
                    

                    <div className="mt-2">
                      <button
                        className={`flex gap-2 w-full bg-black text-white px-3 py-2 rounded-full items-center justify-center`}
                        onClick={() => rentBtnClick(data)}
                      >
                        <span className="text-sm">Rent</span>
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AFTER SUBMIT */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          
          {/* BACKDROP */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setShowModal(false)}
          />

          {/* MODAL BOX */}
          <div className="relative overflow-auto bg-white rounded-xl shadow-lg lg:w-9/12 xl:w-8/12 2xl:w-6/12 p-6 max-h-[90vh] overflow-y-auto">
            
            <h2 className="text-xl font-semibold mb-3">
              Confirm Transaction
            </h2>

            <div className="flex flex-col gap-3">
              <FormCard title='Product'>
                <span>{selectedItem.brandName} {selectedItem.productName}</span>
              </FormCard>
              <FormCard title='Customer'>
                <StateManagedSelect options={customerOptions} value={selectedCustomer} onInputChange={customerOnInput} onChange={setSelectedCustomer} placeholder='Select Customer' />
              </FormCard>
              <FormCard title='Rental Date'>
                <DatePicker disableClock={false} value={rentalDate} onChange={setRentalDate} />
              </FormCard>
              <FormCard title='Rental Options'>
                <div className="flex gap-2">
                  {RentalOptions.map((data, i) => {
                    return(
                      <button kry={i} 
                        className={`border rounded-full px-3 py-1 text-sm ${selectedRentalOptions === data.value ? 'bg-black text-white' : ''}`}
                        onClick={() => { setSelectedRentalOptions(data.value) }}
                      >
                        {data.label}
                      </button>
                    )
                  })}
                </div>
              </FormCard>

              <FormCard title='Duration'>
                <div className="flex gap-3">
                  <button 
                    className="bg-black text-white rounded-full px-3"
                    onClick={() => setDuration(prev => Math.max(1, parseInt(prev) - 1))}
                  >
                    -
                  </button>
                  <span>{duration} {RentalOptions.find(x => x.value === selectedRentalOptions).label}</span>
                  <button 
                    className="bg-black text-white rounded-full px-3"
                    onClick={() => setDuration(prev => parseInt(prev) + 1)}
                  >
                    +
                  </button>
                </div>
              </FormCard>

              <FormCard title='Amount'>
                {/* <span>Rp {money(parseInt(duration) * parseFloat(selectedRentalOptions === '1' ? selectedItem.rentalPriceHour : (selectedRentalOptions === '2' ? selectedItem.rentalPriceSession : selectedItem.rentalPriceDay)))}</span> */}
                <span>{ money(amount) }</span>
              </FormCard>

              <FormCard title='Discount'>
                <div className="w-24 flex gap-2 items-center">
                  <input className="input" value={discount} 
                    inputMode="number"
                    onChange={(e) => {
                      let value = Number(removeNonNumeric(e.target.value))
                      value = Math.min(100, Math.max(0, value))
                      setDiscount(value.toString())
                    }}
                  />
                  <span>%</span>
                </div>
                
              </FormCard>

              <FormCard title='Delivery Date'>
                <DatePicker disableClock={false} value={deliveryDate} onChange={setDeliveryDate} />
              </FormCard>

              <FormCard title='Delivery Location'>
                <input className="input" value={deliveryLocation} onChange={(e) => {setDeliveryLocation(e.target.value)}} />
              </FormCard>

              <FormCard title='Delivery Fee'>
                <input className="input" value={deliveryFee} onChange={(e) => {setDeliveryFee(money(e.target.value))}} />
              </FormCard>

              <FormCard title='Nett Amount'>
                {/* <span>Rp {money((parseInt(duration) * parseFloat(selectedRentalOptions === '1' ? selectedItem.rentalPriceHour : (selectedRentalOptions === '2' ? selectedItem.rentalPriceSession : selectedItem.rentalPriceDay))) + parseFloat(deliveryFee.replaceAll(',', '')))}</span> */}
                <span>{ money(nettAmount) }</span>
              </FormCard>

              <FormCard title='Payment'>
                <div className="flex gap-2">
                  {PaymentTypeOptions.map((data, i) => {
                    return (
                      <button 
                        className={` 
                          px-3 py-1 border rounded-full text-sm
                          ${data.value === paymentType ? 'bg-black text-white' : ''}`
                        }
                        onClick={() => {setPaymentType(data.value)}}
                      >
                        {data.label}
                      </button>
                    )
                  })}
                </div>
              </FormCard>

              <FormCard title='Remark'>
                <input className="input" value={remark} onChange={(e) => {setRemark(e.target.value)}} />
              </FormCard>
            </div>
            
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-full border"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-full bg-black text-white"
                onClick={() => {
                  submitBtnClick();
                  setShowModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}